import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material'
import { ExpandMore, RequestPage } from '@vedmarket/ui-kit'
import { COLORS } from 'config/constants'

const ProposalAccordion = ({ children, hideHeading = false }: ApplicationProposalAccordionProps) => {
  const { t } = useTranslation()

  const accordionId = useId()

  if (hideHeading) {
    return <>{children}</>
  }

  return (
    <Accordion
      defaultExpanded
      className='application-proposal-accordion'
      sx={{ boxShadow: 'none' }}
    >
      <AccordionSummary
        expandIcon={<ExpandMore width={32} height={32} />}
        id={`${accordionId}-summary`}
        aria-controls={`${accordionId}-content`}
        sx={{
          padding: '12px 24px',
        }}
      >
        <Typography
          variant='h5'
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            fontWeight: 700,
          }}
        >
          <RequestPage
            width={32}
            height={32}
            style={{
              color: COLORS.LIGHT_TEXT_DISABLED_OPACITY,
              flexShrink: 0,
            }}
          />
          {t('applications__text__proposal')}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {children}
      </AccordionDetails>
    </Accordion>
  )
}

export default ProposalAccordion
